import { BaseColumnCheckbox, Colors } from '@gripp/shared-ui';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { Platform, StyleProp, StyleSheet, Text } from 'react-native';

const getLabel = (labelStyle: StyleProp<any>, label: string) => {
  return <Text style={[labelStyle, styles.cellText]}>{label ?? '-'}</Text>;
};

export const useAddonAssetColumns = () => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper();

  const createCheckboxColumn = (
    accessor: string,
    cell: any,
    header: any
  ): ColumnDef<unknown, never> => {
    return columnHelper.accessor(accessor, {
      cell,
      header,
      meta: { style: styles.checkboxCell },
    });
  };

  const columns: ColumnDef<unknown, never>[] = [
    createCheckboxColumn(
      'selected',
      BaseColumnCheckbox.checkbox,
      BaseColumnCheckbox.checkboxHeader
    ),
    columnHelper.accessor('name', {
      cell: (info) => getLabel(styles.nameLabel, info.getValue()),
      header: () => t('assets.list.name'),
      meta: { style: styles.cell },
    }),
    columnHelper.accessor('productName', {
      cell: (info) => getLabel(styles.greyLabel, info.getValue()),
      header: () => t('product.list.name'),
      meta: { style: styles.cell },
    }),
  ];

  return columns;
};

const styles = StyleSheet.create({
  cell: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    paddingVertical: 4,
    ...Platform.select({
      web: {
        height: 50,
        paddingRight: 16,
      },
      default: {
        height: 68,
        paddingRight: 12,
      },
    }),
  },
  checkboxCell: {
    maxWidth: 50,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  nameLabel: {
    color: Colors.role.textStrong,
  },
  greyLabel: {
    color: Colors.role.textSecondary,
  },
  cellText: {
    fontSize: 16,
    lineHeight: 17,
    ...Platform.select({
      web: {
        fontWeight: '500',
        flexWrap: 'nowrap',
      },
      default: {
        fontWeight: '400',
        flexWrap: 'wrap',
      },
    }),
    color: Colors.role.textStrong,
  },
});
